import { SupportIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
function openGuides() {
  window.open("https://www.portant.co/docs/", "_blank");
}

function GuidesButton() {
  const { t } = useTranslation();
  return (
    <button className='flex items-center gap-1 font-gilroy text-sm font-semibold hover:underline my-auto text-gray-400 hover:text-blue cursor-pointer' onClick={openGuides}>
      <SupportIcon className='w-4 h-4' /> {t("Guides")}
    </button>
  );
}

export default GuidesButton;